// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void,
  isConfirming: boolean,
  // ENG-31072: defaults to true so an unwired caller keeps the fuller (safer) wording.
  hasTransferCertifications?: boolean,
};

// Dedicated confirmation modal for canceling an active resident transfer (ENG-30150, OQ2). Matches
// the approved mockup: "Cancel Transfer" title + X close, two-paragraph body, right-aligned
// Cancel (text) + Confirm (contained, loading while the mutation runs).
function CancelTransferModal({
  open,
  onClose,
  onConfirm,
  isConfirming,
  hasTransferCertifications = true,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={<FormattedMessage {...messages.cancelTransferModalTitle} />}
      actionsProps={[
        {
          children: <FormattedMessage {...messages.cancelTransferDismiss} />,
          onClick: onClose,
          variant: 'text',
          disabled: isConfirming,
        },
        {
          children: <FormattedMessage {...messages.cancelTransferConfirm} />,
          submitButton: true,
          disabled: isConfirming,
          isSubmitting: isConfirming,
          onClick: onConfirm,
        },
      ]}
      ModalProps={{
        sx: {
          '.MuiPaper-root': {
            maxWidth: '600px',
            width: '100%',
          },
        },
      }}
    >
      <Stack direction={'column'} spacing={2}>
        <Typography variant={'bodyMedium'}>
          <FormattedMessage
            {...(hasTransferCertifications
              ? messages.cancelTransferModalBody1
              : messages.cancelTransferModalBody1Conventional)}
          />
        </Typography>
        <Typography variant={'bodyMedium'}>
          <FormattedMessage {...messages.cancelTransferModalBody2} />
        </Typography>
      </Stack>
    </Modal>
  );
}

export default CancelTransferModal;
